import { formatCnpj, formatDocumentNumber } from '@btime/helpers'
import React from 'react'

import Input from './Input'

const generateMaskedInput =
  ({ mask, ...defaultProps }) =>
  ({ ...props }) =>
    <Input {...defaultProps} {...props} replaceValue={mask} />

export const CnpjOrCpfInput = generateMaskedInput({
  mask: formatDocumentNumber,
  limit: 18
})

export const CnpjInput = generateMaskedInput({
  mask: formatCnpj,
  limit: 18
})
